<template>
  <div
    class="cke_editable cke_editable_themed cke_contents_ltr cke_show_borders"
  >
    <p style="text-align: center">
      <span style="font-size: 14px"><strong>有看投用户使用协议</strong></span>
    </p>

    <p><strong>1.服务条款的确认</strong></p>

    <p>
      有看投平台根据本服务条款及对该条款的修改向用户提供服务。本服务条款具有合同法上的法律效力。
    </p>

    <p>
      如果您对协议的任何条款表示异议，您可以选择不注册，一旦您点选&ldquo;注册&rdquo;并通过注册程序，即表示您自愿接受本协议之所有条款，并已成为有看投平台的注册用户。用户在使用有看投的同时，同意接受平台注册用户服务提供的各类信息服务。
    </p>

    <p>
      有看投有权根据互联网的发展和中华人民共和国有关法律、法规的变化，不断地完善服务质量并依此修改本用户协议条款。用户的权利以及义务的表述，均以最新的服务条款为准。服务条款一旦发生变动，将会在重要页面上提示修改内容。如用户仍继续在服务期内使用该软件即视为自动接受服务条款的变动。
    </p>

    <p>
      有看投平台的注册用户承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。
    </p>

    <p>有看投平台的注册用户承诺其注册的账号名称不含以下情况：</p>

    <p>&bull; 违反宪法或法律法规规定的;</p>

    <p>&bull; 反危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的;</p>

    <p>&bull; 损害国家荣誉和利益的，损害公共利益的;</p>

    <p>&bull; 煽动民族仇恨、民族歧视，破坏民族团结的;</p>

    <p>&bull; 破坏国家宗教政策，宣扬邪教和封建迷信的;</p>

    <p>&bull; 散布谣言，扰乱社会秩序，破坏社会稳定的;</p>

    <p>&bull; 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的;</p>

    <p>&bull; 侮辱或者诽谤他人，侵害他人合法权益的;</p>

    <p>&bull; 含有法律、行政法规禁止的其他内容的。</p>

    <p><strong>2.服务内容及修改、中断、终止</strong></p>

    <p>
      2.1
      有看投平台服务的具体内容由本平台根据实际情况提供，并对所提供之服务拥有最终解释权。
    </p>

    <p>
      2.2
      有看投平台中部分服务仅向注册用户提供，与相关服务有关的设备(如个人电脑、手机、及其他与接入互联网或移动网有关的装置)及所需的费用(如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费)均由注册用户自行负担。
    </p>

    <p>
      2.3 鉴于网络服务的特殊性，
      有看投会不断完善技术和服务水平，但不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也不作担保。
    </p>

    <p>
      2.4
      有看投需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成网络服务(包括收费网络服务)在合理时间内的中断，有看投平台无需为此承担责任。
    </p>

    <p><strong>3.注册用户帐号及密码</strong></p>

    <p>
      3.1用户的帐号，密码和安全性。用户一旦注册成功，成为有看投的合法用户，将得到一个密码和用户名。该帐号和密码由用户负责保管;用户将对用户名和密码安全负全部责任。另外，每个用户都要对以其用户名进行的所有活动和事件负全责。用户若发现任何非法使用用户帐号或存在安全漏洞的情况，请立即通告APP运营方。
    </p>

    <p><strong>4. 注册信息和隐私保护</strong></p>

    <p>
      4.1
      用户隐私制度。尊重用户个人隐私是有看投的基础原则。有看投不会在未经用户授权时公开或透露其注册资料及其它保存在有看投的非公开内容，除非：
    </p>

    <p>&bull; 事先获得用户的明确授权;</p>

    <p>&bull; 只有透露你的个人资料，才能提供你所要求的产品和服务;</p>

    <p>&bull; 根据有关的法律法规要求;</p>

    <p>&bull; 按照相关政府主管部门的要求;</p>

    <p>&bull; 为维护有看投平台的合法权益。</p>

    <p>
      4.2
      在您注册有看投帐户，使用平台产品或服务，或访问平台网页时，有看投会收集您的个人身份识别资料，并会将这些资料用于：改进为您提供的服务及网页内容。
    </p>

    <p><strong>5. 用户权责</strong></p>

    <p>
      5.1符合下列条件之一的个人、组织，才能申请成有看投用户、使用本协议项下的服务：
    </p>

    <p>5.1.1 年满十八周岁，并具有民事权利能力和民事行为能力的自然人;</p>

    <p>5.1.2 未满十八周岁，但监护人(包括但不仅限于父母)予以书面同意的自然人;</p>

    <p>
      5.1.3
      根据中国法律、法规成立并合法存在的公司等企业法人、事业单位、社团组织和其他组织。无民事行为能力人、限制民事行为能力人以及无经营或特定经营资格的组织不当注册为用户的，其与本公司之间的协议自始无效，本公司一经发现，有权注销该用户。
    </p>

    <p>
      5.2
      用户有权按照有看投规定的程序和要求使用平台向注册及付费用户提供的各项网络服务，如果注册用户对该服务有异议，可以与App联系以便得到及时解决。
    </p>

    <p>
      5.3 用户须同意接受有看投通过短信或其他方式向注册用户发送相关服务信息。
    </p>

    <p>
      5.5
      用户在使用有看投服务时，必须遵守中华人民共和国相关法律法规的规定，不得利用本服务进行任何违法或不正当的活动，包括但不限于下列行为∶
    </p>

    <p>5.5.1 制作、复制、发布、传播或以其它方式传送含有下列内容之一的信息：</p>

    <p>&bull; 反对宪法所确定的基本原则的</p>

    <p>&bull; 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的;</p>

    <p>&bull; 损害国家荣誉和利益的;</p>

    <p>&bull; 煽动民族仇恨、民族歧视、破坏民族团结的;</p>

    <p>&bull; 破坏国家宗教政策，宣扬邪教和封建迷信的;</p>

    <p>&bull; 散布谣言，扰乱社会秩序，破坏社会稳定的;</p>

    <p>&bull; 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的;</p>

    <p>&bull; 侮辱或者诽谤他人，侵害他人合法权利的;</p>

    <p>&bull; 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的;</p>

    <p>&bull; 以非法民间组织名义活动的;</p>

    <p>
      &bull;
      含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容;
    </p>

    <p>
      &bull;
      含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的。
    </p>

    <p>5.5.2 不得利用有看投服务从事以下活动：</p>

    <p>&bull; 未经允许，进入计算机信息网络或者使用计算机信息网络资源;</p>

    <p>&bull; 未经允许，对计算机信息网络功能进行删除、修改或者增加;</p>

    <p>
      &bull;
      未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加;
    </p>

    <p>&bull; 故意制作、传播计算机病毒等破坏性程序;</p>

    <p>&bull; 其他危害计算机信息网络安全的行为。</p>

    <p>
      5.6
      用户不得对有看投任何部分通过任何方式进行复制、出售、转售或用于任何其它商业目的。
    </p>

    <p><strong>6. 知识产权</strong></p>

    <p>
      6.1
      有看投平台网站及网站所使用的任何相关软件、程序、内容，包括但不限于作品、图片、档案、资料、网站构架、网页设计、经由本网站或广告商向用户呈现的广告或资讯，均由本公司或其它权利人依法享有相应的知识产权，包括但不限于著作权、商标权、专利权或其它专属权利等，受到相关法律的保护。未经本公司或权利人明示授权，用户保证不修改、出租、出借、出售、散布本APP
      所使用的上述任何资料和资源，或根据上述资料和资源制作成任何种类物品。
    </p>

    <p>
      6.2
      本公司授予用户不可转移及非专属的使用权，使用户可以通过单机计算机使用本APP
      的目标代码(以下简称&ldquo;软件&rdquo;)，但用户不得且不得允许任何第三方，复制、修改、创作衍生作品、进行还原工程、反向组译，或以其它方式破译或试图破译源代码，或出售、转让&ldquo;软件&rdquo;或对&ldquo;软件&rdquo;进行再授权，或以其它方式移转&ldquo;软件&rdquo;之任何权利。用户同意不以任何方式修改&ldquo;软件&rdquo;，或使用修改后的&ldquo;软件&rdquo;。
    </p>

    <p><strong>7. 其他</strong></p>

    <p>
      7.1
      因不可抗力或者其他意外事件，使得本协议的履行不可能、不必要或者无意义的，双方均不承担责任。本协议所称之不可抗力意指不能预见、不能避免并不能克服的客观情况，包括但不限于战争、台风、水灾、火灾、雷击或地震、罢工、暴动、法定疾病、黑客攻击、网络病毒、电信部门技术管制、政府行为或任何其它自然或人为造成的灾难等客观情况。
    </p>

    <p>
      7.2
      本条款及其修订本的有效性、履行和与本条款及其修订本效力有关的所有事宜，将受中华人民共和国法律约束，任何争议仅适用中华人民共和国法律。
    </p>

    <p>
      7.3
      因本条款所引起的用户与本公司的任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此同意将纠纷或争议提交本公司住所地有管辖权的人民法院诉讼解决。
    </p>

    <p>
      7.4用户正确提交注册程序所需的资料并确认本协议后，本协议在有看投与用户之间成立并生效。
    </p>

    <p>
      7.5本协议生效前的注册用户只需要使用原用户名及密码登录App重新接受并确认本协议，即可继续使用App的服务。
    </p>

    <p>7.6协议有效期：从用户同意本协议或使用有看投起至用户注销有看投服务止。</p>

    <p>7.7有看投相关客服的电子邮箱以及联系方式以App官网上注明的为准。</p>

    <p>7.8使用有看投即表示接受平台服务协议及其所有附件。</p>

    <p>7.9本协议的最终解释权归有看投所有。</p>
  </div>
</template>

<script>
export default {
  name: 'Regist'
}
</script>
<style>
p {
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
.cke_editable {
  font-size: 13px;
  line-height: 1.6;
  word-wrap: break-word;
}
body {
  font-family: sans-serif, Arial, Verdana, 'Trebuchet MS', 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol';
  font-size: 12px;
  color: #333;
  background-color: #fff;
  margin: 20px;
  display: block;
}
</style>
